// useNewRheologyDataQueries.ts
import {
  MineModelDto,
  ProjectDto,
  useMineModelQuery,
  useProjectQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { HOUR_IN_MILLISECONDS } from 'config';

type RouteParams = Readonly<Record<'entityId', string | undefined>>;

export type NewRheologyDataQueries = [
  UseQueryResult<ProjectDto>,
  UseQueryResult<MineModelDto | undefined>
];

const useNewRheologyDataQueries = (params: RouteParams): NewRheologyDataQueries => {
  const entityId = params.entityId ?? '';
  const enabled = Boolean(params.entityId);

  const projectQuery = useProjectQuery(entityId, {
    staleTime: HOUR_IN_MILLISECONDS,
    enabled,
  });

  const mineModelQuery = useMineModelQuery({ mineModelId: entityId }, {
    staleTime: HOUR_IN_MILLISECONDS,
    enabled,
  });

  return [projectQuery, mineModelQuery];
};

export default useNewRheologyDataQueries;
